"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationDataClient = void 0;
const headers = {
    'User-Id': '__userId__',
    'Content-Type': 'application/json',
};
class ApplicationDataClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.resourceHostId = `myvw-customer-profile-application-data-${this.stage}`;
    }
    async getPersonalApplicationData() {
        const response = await this.authService.get(this.resourceHostId, `v1/userData/__userId__/__aud__`, headers);
        if (response.status === 404) {
            return {
                showTeaser: true,
                teaserType: '404',
            };
        }
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const json = (await response.json());
        return {
            showTeaser: !json.hidePspStpTeaser,
            teaserType: '200',
        };
    }
    async putPersonalApplicationData(payload) {
        const endpoint = 'v1/userData/__userId__/__aud__';
        const getResponse = await this.authService.get(this.resourceHostId, endpoint, headers);
        const eTag = getResponse.status === 404 ? '0' : getResponse.headers.get('Etag');
        if (!eTag) {
            throw new Error(`Cannot get eTag from ${this.resourceHostId}/${endpoint}`);
        }
        try {
            const response = await this.authService.put(this.resourceHostId, `v1/userData/__userId__/__aud__`, JSON.stringify(payload), { 'User-Id': '__userId__', 'If-Match': eTag, 'Content-Type': 'application/json' });
            if (!response.ok) {
                throw new Error(response.statusText);
            }
        }
        catch (error) {
            if (error instanceof Error) {
                throw new Error(error.message);
            }
            throw new Error('application data put failed');
        }
    }
}
exports.ApplicationDataClient = ApplicationDataClient;
//# sourceMappingURL=ApplicationDataClient.js.map